export const nameMismatchDetailsModalStyles = {
  paper: {
    margin: 0,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: '16px 16px 0 0',
    maxWidth: '100%',
    width: '100%',
  },
  container: {
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    pb: 4,
    pt: 2,
    px: 2.5,
    borderRadius: '16px 16px 0 0',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Noto Sans",
    fontSize: '20px',
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: '160%', 
    letterSpacing: '0.15px',
  },
  closeButton: {
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: '50%',
    flexShrink: 0,
    '&:hover': {
      bgcolor: 'rgba(0,0,0,0.04)',
    },
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  fieldLabel: {
    color: 'rgba(0, 0, 0, 0.60)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Noto Sans",
    fontSize: '14px',
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: '143%',
    letterSpacing: '0.17px',
  },
  fieldValue: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Noto Sans",
    fontSize: '16px',
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: '150%', 
    letterSpacing: '0.15px',
    overflowWrap: 'anywhere',
  },
};
